import React from 'react'
import { Container, Typography, List, ListItem, ListItemText, Link } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const CookiesPolicyRu = () => {
  const theme = useTheme()

  return (
    <Container
      maxWidth='md'
      sx={{
        py: 4,
        color: theme.palette.primary.contrastText,
        '& p, & ul': { textIndent: '2em' }
      }}
    >
      <Typography variant='h4' sx={{ mt: 0, mb: 8, textAlign: 'center' }}>
        Политика cookie
      </Typography>
      <Typography paragraph>
        Настоящая Политика в отношении использования файлов cookie (далее — Политика Cookie) разработана в отношении
        файлов cookie, использующихся на сайте Общества с ограниченной ответственностью «СИЛК» (далее — Компания) по
        адресу:{' '}
        <Link href='https://gosilk.ru' target='_blank'>
          {'https://gosilk.ru'}
        </Link>{' '}
        (далее — Сайт).
      </Typography>
      <Typography paragraph>
        Пользователь, принимая настоящую Политику, подтверждает ознакомление и согласие со всеми ее условиями.
      </Typography>
      <Typography paragraph>
        Пользователь выражает согласие на обработку информации при посещении любой из страниц Сайта.
      </Typography>
      <Typography variant='h6' sx={{ mt: 10, mb: 4, textAlign: 'center' }}>
        Что такое файлы cookie?
      </Typography>
      <Typography paragraph>
        Файлы cookie — текстовые файлы, которые сохраняются на устройстве (персональном компьютере, ноутбуке, планшете,
        мобильном телефоне и т.п.) при посещении Сайта. Файлы cookie помогают обеспечить нормальное и безопасное
        функционирование Сайта. Они позволяют собирать информацию о продуктах, которыми интересуются посетители Сайта, а
        также учитывают использованную при посещении навигацию.
      </Typography>
      <Typography paragraph>
        Такие файлы идентифицируют посетителя Сайта как Пользователя, но не как личность, и, после того как будет
        проведена процедура анализа, удаляются из системы автоматически.
      </Typography>
      <Typography variant='h6' sx={{ mt: 10, mb: 4, textAlign: 'center' }}>
        Виды файлов cookie
      </Typography>
      <Typography paragraph>
        В зависимости от используемых Вами браузера и устройства, используются разные наборы файлов cookie, включающие в
        себя необходимые для бесперебойного и надежного функционирования Сайта:
      </Typography>
      <List sx={{ p: 0 }}>
        <ListItem disableGutters>
          <ListItemText primary='- Технические файлы cookie. Отключение данного типа Файлов cookie может привести к ограничению Пользователя в доступе к определенным функциональным возможностям Сайта;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- Функциональные файлы cookie. Позволяют сохранять информацию о Вас, например, страну, из которой Вы посещаете Сайт, используемый язык или регион, в котором Вы находитесь. Эта информация может быть использована для предоставления Вам более подходящего опыта в соответствии с Вашим выбором. Отключение данного типа файлов cookie также может повлечь за собой ограниченное функционирование Сайта;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- Сессионные файлы cookie временные и сохраняют информацию о совершенной Пользователем активности на Сайте в течение одной сессии (т.е. до момента закрытия Сайта Пользователем);' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- Аналитические файлы cookie. Данный тип файлов cookie необходим для отслеживания  страниц/разделов Сайта, посещаемых Пользователем, а также выявления возможных ошибок в работе Сайта. Информация, собираемая о Пользователях данным видом Файлов cookie, является анонимной и необходима для эффективного поддержания и обновления Сайта, а также для предоставления Пользователю таргетингового контента;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- Маркетинговые файлы cookie – для измерения эффективности рекламы, анализа аудитории и развития услуг Сайта, включая эффективность рекламы, а также измерения эффективности персонализированного контента и рекламы.' />
        </ListItem>
      </List>
      <Typography variant='h6' sx={{ mt: 10, mb: 4, textAlign: 'center' }}>
        Для чего используются файлы cookie?
      </Typography>
      <Typography paragraph>При посещении Сайта, файлы cookie могут быть использованы в следующих целях:</Typography>
      <List sx={{ pl: 0 }}>
        <ListItem disableGutters>
          <ListItemText primary='- обеспечение функционирования и безопасности сайта;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- учет предпочтений Пользователя, получение информации о том, как Пользователь попал на Сайт;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- идентификация Пользователя (распознавание браузера и/или устройства каждый раз, когда осуществляется вход на Сайт, сохранение настроек экрана и браузера и/или сохранение логина и пароля Пользователей для входа на Сайт);' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- улучшение взаимодействия Сайта и Пользователей, улучшение навигации по Сайту;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- усовершенствование оказываемых услуг, разработка новых решений для функционирования Сайта.' />
        </ListItem>
      </List>
      <Typography variant='h6' sx={{ mt: 10, mb: 4, textAlign: 'center' }}>
        Управление файлами cookie
      </Typography>
      <Typography paragraph>
        Вы можете удалить, блокировать или иным образом ограничить использование файлов cookie в настройках Вашего
        браузера. Для этого следуйте инструкциям на страницах справки Вашего браузера. Просим обратить внимание на то,
        что файлы cookie являются важной составляющей эффективной работы Сайта, поэтому удаление, блокировка или иное
        ограничение использования файлов cookie, может ограничить доступ Пользователя к полному функционалу Сайта.
      </Typography>
      <Typography variant='h6' sx={{ mt: 10, mb: 4, textAlign: 'center' }}>
        Обновление Политики обработки файлов cookie
      </Typography>
      <Typography paragraph>
        Это краткое описание использования Компанией файлов cookie на сегодняшний момент. Компания вправе изменить
        способы использования файлов cookie, в таком случае будет обновлена и настоящая Политика в отношении
        использования файлов cookie. При возникновении вопросов или предложений по настоящей Политике, Пользователь
        может обратиться с запросом по электронному адресу Компании:{' '}
        <Link href='mailto:report@gosilk.ru' target='_blank'>
          {'report@gosilk.ru'}
        </Link>
        .
      </Typography>
    </Container>
  )
}

export default CookiesPolicyRu
